import { UseMutationOptions, useMutation } from '@tanstack/react-query';
import { AxiosError } from 'axios';

import { hideModal } from '@components/modal';
import { useToaster } from '@components/toaster';
import { useScopedTranslate } from '@locale/translate';

import { updatePassword } from 'api/users';

export type UpdatePassword = {
  oldPassword: string;
  password1: string;
  password2: string;
};

type UpdatePasswordError = AxiosError<{ oldPassword: string[] }>;

export const useUpdatePassword = (
  setOldPasswordError: (errors: string[]) => void,
  options?: UseMutationOptions<unknown, UpdatePasswordError, UpdatePassword>,
) => {
  const { t } = useScopedTranslate(locale);
  const { showSuccess, showError } = useToaster();
  return useMutation({
    ...options,
    mutationFn: (data) => updatePassword(data),
    onSuccess: () => {
      showSuccess(t('updated'));
      hideModal();
    },
    onError: (data) => {
      if (data?.response?.data?.oldPassword) {
        setOldPasswordError(data.response.data.oldPassword);
      }
      showError(t('passwordNotUpdated'));
    },
  });
};

const locale = {
  en: {
    updated: 'Password updated',
    passwordNotUpdated: 'Unable to change password',
  },
  is: {
    updated: 'Lykilorð uppfært',
    passwordNotUpdated: 'Ekki tókst að uppfæra lykilorð',
  },
};
